import { useAppTheme } from "../../useAppTheme";
import Box from "../Box";
import { Skeleton } from "../Skeleton";

export const LeaderboardRankRowSkeleton = () => {
	const theme = useAppTheme();

	return (
		<Box width="100%">
			<Box
				height={60}
				flexDirection="row"
				alignItems="center"
				justifyContent="space-between"
				paddingLeft={12}
				paddingRight={16}
			>
				<Box flexDirection="row" alignItems="center" gap={12}>
					<Skeleton width={14} height={12} />
					<Skeleton size={38} variant="circle" />
					<Skeleton width={80} height={14} />
				</Box>
				<Skeleton width={56} height={32} />
			</Box>
			<Box height={1} backgroundColor={theme.colors.surfaceVariant} />
		</Box>
	);
};
